import styled from 'styled-components'
import { Button as ButtonCommon, Typography } from 'primsell-shared-layer/components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
  padding: 56px 0 32px 0;
`

export const Button = styled(ButtonCommon)`
  margin-top: 16px;
`

export const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  line-height: 140%;
  color: ${baseTheme.colors.lightDark};
`
